const HUMAN_PARTICIPANT_IDENTITY_KEY_PREFIXES = Object.freeze([
  'mentor',
  'auditor',
  'patient',
  'user',
  'client',
  'consumer',
  'panelist',
  'observer',
])

export function isHumanParticipantIdentityKeyPrefix(prefix) {
  return HUMAN_PARTICIPANT_IDENTITY_KEY_PREFIXES.includes(prefix)
}

